import { extractQueryGetItem } from 'core/utils/apollo/extractGetItem';
import {
  useGetCandidateBatchQuery,
  useOnUpdateCandidateBatchSubscription
} from 'generated-graphql/hooks/apollo-hooks';
import { sanitizeObject } from 'utils/fomatting';

type Props = {
  id: string | undefined;
};

export const useGetCandidateBatchWithSubscription = ({ id }: Props) => {
  const { data: candidateBatchData, updateQuery } = useGetCandidateBatchQuery({
    variables: {
      id: id as string
    },
    skip: !id
  });

  const { error: updateBatchError } = useOnUpdateCandidateBatchSubscription({
    variables: {
      filter: {
        id: { eq: id as string }
      }
    },
    skip: !id,
    onData: ({ data: { data } }) => {
      const candidateBatchUpdated = data?.onUpdateCandidateBatch;

      if (candidateBatchUpdated?.status) {
        updateQuery((prevData) => {
          if (prevData.getCandidateBatch) {
            return {
              ...prevData,
              getCandidateBatch: {
                ...prevData.getCandidateBatch,
                ...sanitizeObject(candidateBatchUpdated)
              }
            };
          }

          return prevData;
        });
      }
    }
  });

  const candidateBatch = extractQueryGetItem(candidateBatchData);

  return {
    candidateBatch,
    updateQuery,
    subscriptionError: updateBatchError
  };
};
